import { AppRouter } from './routes';
import { ToastContainer } from './components/common';
import { QuotaWall } from './components/freemium';
import { MarketingConsentModal } from './components/MarketingConsentModal';

function App() {
  return (
    <>
      <AppRouter />
      <ToastContainer />
      <QuotaWall />
      <MarketingConsentModal />
    </>
  );
}

export default App;
